import { sameLayout, wheelPositionsOf } from '../domain/layout';

const renderCompatibilityKey = (renderModelKey, renderLayoutKey) => (
  `${renderModelKey || ''}|${renderLayoutKey || ''}`
);

const positionKey = (ref) => {
  const slot = ref.slot ? `-${ref.slot}` : '';
  return `${ref.axle}|${ref.side}${slot}`;
};

const refsOf = (layoutOrVehicle) => {
  if (layoutOrVehicle?.positionRefs) return layoutOrVehicle.positionRefs.map(positionKey);
  const layout = layoutOrVehicle?.layout || layoutOrVehicle;
  return layout?.axles ? wheelPositionsOf(layout).map(positionKey) : [];
};

const samePositions = (preset, vehicle) => {
  const presetRefs = preset.wheels
    ? preset.wheels.map((placement) => positionKey(placement.ref))
    : refsOf(preset.layout);
  const vehicleRefs = refsOf(vehicle);
  return presetRefs.length === vehicleRefs.length
    && new Set(presetRefs).size === new Set(vehicleRefs).size
    && presetRefs.every((ref) => vehicleRefs.includes(ref));
};

const findPresetForRenderIdentity = (presets, identity, vehicle) => {
  if (!identity?.renderModelKey || !identity?.renderLayoutKey || !vehicle?.layout) return undefined;
  const key = renderCompatibilityKey(identity.renderModelKey, identity.renderLayoutKey);
  return presets.find((preset) => (
    renderCompatibilityKey(preset.renderModelKey, preset.renderLayoutKey) === key
    && sameLayout(preset.layout, vehicle.layout)
    && samePositions(preset, vehicle)
  ));
};

export {
  findPresetForRenderIdentity,
  positionKey,
  refsOf,
  renderCompatibilityKey,
  samePositions,
};
